import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import {
  createScaffolderFieldExtension,
  type FieldExtensionOptions,
} from '@backstage/plugin-scaffolder-react';
import { UniqueAppName } from './UniqueAppNameExtension';

// Exported as plain options as well as a provided extension. The stock /create
// route registers the extension as a React child; anything rendering a
// template outside that route needs the options (see ../extensions.ts).
export const uniqueAppNameFieldOptions: FieldExtensionOptions<any, any> = {
  name: 'UniqueAppName',
  component: UniqueAppName,
};

export const UniqueAppNameFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension(uniqueAppNameFieldOptions),
);
